export default __webpack_public_path__ + "static/media/google-play-icon.2605c705.svg";